import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { uploadFile } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';

export const useFileUpload = () => {
	const [uploadedFile, setUploadedFile] = useState<File | null>(null);
	const uploadFileMutation = useMutation({
		mutationFn: uploadFile,
	});

	const handleFileUpload = async (): Promise<string | null> => {
		if (!uploadedFile) {
			return null;
		}

		try {
			const formData = new FormData();
			formData.append('file', uploadedFile);

			const response = await uploadFileMutation.mutateAsync({ formData });

			if (response?.payload?.id) {
				return response.payload.id;
			}

			return null;
		} catch {
			showToastV2({
				title: 'Failed to upload document',
				state: 'error',
			});
			return null;
		}
	};

	const removeFile = () => {
		setUploadedFile(null);
	};

	return {
		uploadedFile,
		setUploadedFile,
		removeFile,
		handleFileUpload,
		isUploading: uploadFileMutation.isPending,
	};
};
